/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Basic_PriceInputs */

const ja_playdata_pricing_basic_price = /** @type {(inputs: Playdata_Pricing_Basic_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¥50,000~`)
};

const en_playdata_pricing_basic_price = /** @type {(inputs: Playdata_Pricing_Basic_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¥50,000~`)
};

/**
* | output |
* | --- |
* | "¥50,000~" |
*
* @param {Playdata_Pricing_Basic_PriceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_basic_price = /** @type {((inputs?: Playdata_Pricing_Basic_PriceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Basic_PriceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_basic_price(inputs)
	return en_playdata_pricing_basic_price(inputs)
});